import { CancelBookingDto } from "./dtos/CancelBookingDto.schema.d";
import { NewBooking } from "./dtos/NewBooking.schema.d";
import { BookingDetails } from "./dtos/BookingDetails.schema.d";
import axios from "axios";
import { Booking } from "./dtos/Booking.schema";
import { deepClone } from "@/misc/helpers";

export const getBookings = async (
  start: Date,
  end: Date,
  stationIds: string[] | undefined = undefined
): Promise<Booking[]> => {
  const res = await axios.get<Booking[]>("/bookings", {
    params: {
      start: start.toISOString(),
      end: end.toISOString(),
      stations: stationIds?.join(",") ?? undefined,
    },
  });
  return res.data;
};

export const createBooking = async (
  booking: NewBooking
): Promise<BookingDetails> => {
  const res = await axios.post<BookingDetails>("/bookings", booking);
  console.log(res.status);
  return res.data;
};

export const getBookingDetails = async (
  bookingId: string
): Promise<BookingDetails> => {
  const res = await axios.get<BookingDetails>(`/bookings/${bookingId}`);
  return res.data;
};

export const cancelWholeBooking = async (bookingId: string): Promise<void> => {
  const res = await axios.delete<void>(`/bookings/${bookingId}`);
};

export const downloadBookingInvoices = async (
  bookingId: string
): Promise<void> => {
  const res = await axios.get(`/bookings/${bookingId}/invoice`, {
    responseType: "blob",
  });

  window.open(URL.createObjectURL(new Blob([res.data])));
};

export const cancelSubBooking = async (
  bookingId: string,
  subBookingId: string,
  info: CancelBookingDto
): Promise<void> => {
  const res = await axios.post<void>(
    `/bookings/${bookingId}/sub-bookings/${subBookingId}/cancel`,
    info
  );
};

export const downloadBookingInvoice = async (
  bookingId: string,
  subBookingId: string
): Promise<void> => {
  const res = await axios.get(
    `/bookings/${bookingId}/sub-bookings/${subBookingId}/invoice`,
    {
      responseType: "blob",
    }
  );

  window.open(URL.createObjectURL(new Blob([res.data])));
};

export const extendBooking = async (
  bookingId: string,
  extension: NewBooking
): Promise<BookingDetails> => {
  const res = await axios.post<BookingDetails>(
    `/bookings/${bookingId}/sub-bookings`,
    extension
  );
  return res.data;
};

export const getMaxExtension = async (
  bookingId: string
): Promise<Date | null> => {
  const res = await axios.get<Date>(`/bookings/${bookingId}/max-extension`);
  if (res.status === 200) {
    return res.data;
  }
  return null;
};
